import { createGlobalStyle, css } from 'styled-components'

const centeredBtn = css`
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    box-shadow: none;
    position: fixed;
    z-index: 1000;
  `

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Roboto', sans-serif;
    background-color: #F9F9FB;
  }

  a {
    text-decoration: none;
  }

  button {
    font-family: 'Roboto', sans-serif;
  }

  .editable-table--first-row {
    background-color: #ededed;
  }

  .row--disabled {
    background-color: #ededed;
  }
    
  .editable-table--first-row input,
  .editable-table--first-row textarea {
    font-weight: bold;
    text-align: center;
  }

  .submit-row--sm {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .centered-anchor--sm {
    display: block;
    ${centeredBtn}
  }
    
  .submit-row--sm {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .ant-table-tbody > tr:hover > td {
    background: inherit !important;
  }
`

export default GlobalStyle
